import { useCallback, useState } from 'react'
import { defineMessages, useIntl } from 'react-intl'
import styled from 'styled-components'
import SmallToggleButton from 'LuxKit/Button/SmallToggleButton'
import Expander from 'components/utils/Expander'
import LePackageUpgradeCardRoomDetails from './LePackageUpgradeCardRoomDetails'

const StyledExpander = styled(Expander)`
  &:not(.expanded) {
    margin-top: 0;
  }
`

const messages = defineMessages({
  hideMoreDetails: {
    id: '6VnOIDgkY79Hzc9yEuhT',
    defaultMessage: 'Hide more details',
  },
  viewMoreDetails: {
    id: '8G7cGZG2tq6jn6DkNINI',
    defaultMessage: 'View more details',
  },
})

interface Props {
  roomType: App.PackageRoomType
  size?: 'small' | 'medium'
}

function PackageUpgradeRoomDetailsExpander({ roomType, size }: Props) {
  const intl = useIntl()
  const [showDetails, setShowDetails] = useState(false)

  const toggleDetails = useCallback(() => {
    setShowDetails(currentShowDetails => !currentShowDetails)
  }, [])

  const hideMoreDetailsLabel = intl.formatMessage(messages.hideMoreDetails)
  const viewMoreDetailsLabel = intl.formatMessage(messages.viewMoreDetails)

  return <>
    <StyledExpander expanded={showDetails}>
      <LePackageUpgradeCardRoomDetails roomType={roomType} size={size} />
    </StyledExpander>
    <SmallToggleButton size="caption" on={showDetails} onClick={toggleDetails}>
      {showDetails ? hideMoreDetailsLabel : viewMoreDetailsLabel}
    </SmallToggleButton>
  </>
}

export default PackageUpgradeRoomDetailsExpander
